import Vue from 'vue';
// 导入模块
import OnlyNumber from './OnlyNumber/index';
import OnlyCharNumber from './OnlyCharNumber/index';
import NoChinese from './NoChinese/index';
import OnlyChinese from './OnlyChinese';
import ClickOutside from './ClickOutside';

// 内容组件
const Components = [
	OnlyNumber,
	OnlyCharNumber,
	NoChinese,
	OnlyChinese,
	ClickOutside
];

Components.forEach(item => Vue.directive(item.name, item.events));


// WEBPACK FOOTER //
// ./src/directive/main.js